<template>
  <div class="props-flow">
    <div class="nav">
      <div class="top">
        <van-sticky>
          <NavBar
            ref="navBar"
            :goBack="goBack"
            :title="$t('specialPropsFlow.研发记录查询')"
          ></NavBar>
        </van-sticky>
      </div>
    </div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="form.category.name"
        readonly
        clickable
        :name="$t('specialPropsFlow.选择卡池')"
        :label="$t('specialPropsFlow.选择卡池')"
        :placeholder="$t('specialPropsFlow.点击选择卡池分类')"
        @click="handleChooseCate"
        :rules="[
          { required: true, message: $t('specialPropsFlow.请选择卡池分类') },
        ]"
      >
      </van-field>
      <div style="margin: 16px">
        <van-button
          class="login-btn"
          :loading="confirmLoading"
          block
          type="primary"
          size="large"
          native-type="submit"
        >
          {{ $t("specialPropsFlow.查询") }}
        </van-button>
      </div>
    </van-form>
    <div v-if="resultVisible">
      <van-row type="flex" class="header">
        <van-col span="6">{{ $t("specialPropsFlow.时间") }}</van-col>
        <van-col span="6">{{ $t("specialPropsFlow.卡池") }}</van-col>
        <van-col span="6">{{ $t("specialPropsFlow.研发结果") }}</van-col>
        <van-col span="6">{{ $t("specialPropsFlow.数量") }}</van-col>
      </van-row>
      <van-row type="flex" v-for="(item, index) in flowData" :key="index">
        <van-col span="6">
          {{ item.time | timeFilter("MM/DD HH:mm") }}
        </van-col>
        <van-col span="6">
          {{ item.prop_name || item.name }}
        </van-col>
        <van-col span="6">
          {{ item.change }}
        </van-col>
        <van-col span="6">
          {{ item.remark }}
        </van-col>
      </van-row>
    </div>
    <div class="tip">
      <span style="color: red">*</span>{{ $t("specialPropsFlow.只显示最近") }}
    </div>
    <div class="tip">
      <span style="color: red">*</span>{{ $t("specialPropsFlow.结果存在延时") }}
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :confirm-button-text="$t('app.确认')"
        :cancel-button-text="$t('app.取消')"
        :columns="currentColumns"
        @confirm="onClassConfirm"
        :loading="pickerLoading"
        @cancel="
          showPicker = false;
          keyword = '';
        "
      >
        <van-search
          slot="title"
          v-model="keyword"
          :placeholder="$t('specialPropsFlow.请输入搜索关键词')"
        />
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { apiGetPropsFlow, apiGetPropCategory } from "@/api/user";
// const PinyinEngine = require('pinyin-engine');
import { mapState } from "vuex";
import storage from "@/utils/storage";

export default {
  name: "PropsFlow",
  data() {
    return {
      confirmLoading: false,
      resultVisible: false,
      pickerLoading: false,
      showPicker: false,
      flowData: [],
      form: {
        category: {
          name: "",
          id: "",
        },
      },
      columns: [],
      // 是否需要分类
      is_classify: false,
      days: 7,
      keyword: "",
      roleList: [],
      currentRoleId: "",
    };
  },
  watch: {
    showPicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
  },
  computed: {
    ...mapState({
      defaultRoleInfo: (state) => state.defaultRoleInfo,
    }),
    currentColumns() {
      return this.columns.filter((item) => {
        const str = (item.text && item.text.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
  },
  created() {
    this.getCategory();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getCategory() {
      this.pickerLoading = true;
      const { session_id } = this.$route.query;
      const params = {
        session_id: session_id ? Number(session_id) : undefined,
      };
      apiGetPropCategory(params)
        .then((res) => {
          if (res.code === 0) {
            this.columns =
              res.data &&
              res.data.map((item) => ({
                text: item.name,
                value: item.id,
              }));
          }
        })
        .finally(() => {
          this.pickerLoading = false;
        });
    },
    onSubmit() {
      if (!this.defaultRoleInfo.role_id) {
        this.$toast(this.$t("specialPropsFlow.请选择角色"));
        return;
      }
      const params = {
        role: this.defaultRoleInfo.role_id,
        category_id: this.form.category.id + "",
        server_id: this.defaultRoleInfo.f_id,
      };
      this.confirmLoading = true;
      apiGetPropsFlow(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "special_props_flow",
              game_id: storage.getGameId(),
              role: this.defaultRoleInfo.role_id,
              server_id: this.defaultRoleInfo.f_id,
            });
            this.flowData = res.data;
            this.resultVisible = true;
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    handleChooseCate() {
      this.showPicker = true;
    },
    onClassConfirm(data) {
      this.form.category.name = data.text;
      this.form.category.id = data.value;
      this.showPicker = false;
    },
  },
};
</script>

<style lang="less" scoped>
.props-flow {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  .nav {
    flex: 0 0 auto;
    .choose-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 44px;
      padding: 0 10px;
      box-sizing: border-box;
      border-bottom: 1px solid #f7f7f7;
      background-color: #fff;
      .label {
        color: #242424;
        font-size: 15px;
      }
    }
    .history {
      display: flex;
      align-items: center;
      i {
        font-size: 20px;
      }
    }
  }
}
/deep/ .van-search {
  padding: 0;
}
/deep/ .van-row {
  color: #646566;
  background-color: #fff;
  &.header {
    color: #000;
    font-size: 14px;
  }
  .van-col {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 4px;
    border-bottom: 1px solid #ebedf0;
  }
}
.tip {
  padding-left: 10px;
  color: #9a9a9a;
  font-size: 14px;
  line-height: 20px;
}
</style>
